import { TripSummaryDefaultTextDisplay } from './TripSummaryDefaultTextDisplay';

export function TripSummaryEventPersonName({ name }: { name: string }) {
  return <TripSummaryDefaultTextDisplay text={name} />;
}
